window.hanabi2026Events = [
    {
        "date":  "2026-06-01",
        "dateText":  "2026-06-01",
        "month":  "6月",
        "day":  "01",
        "weekday":  "月",
        "name":  "地獄の谷の鬼花火",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "登別市/登別温泉 地獄谷展望台",
        "scale":  "24筒",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-02",
        "dateText":  "2026-06-02",
        "month":  "6月",
        "day":  "02",
        "weekday":  "火",
        "name":  "コカ・コーラボトラーズジャパン株式会社プレゼンツ「ビームスペクタクル in ハーバー」",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "横浜市中区/臨港パーク海上",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-03",
        "dateText":  "2026-06-03",
        "month":  "6月",
        "day":  "03",
        "weekday":  "水",
        "name":  "京都芸術花火2026",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "京都市伏見区/京都競馬場",
        "scale":  "約1万3500発",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-06",
        "dateText":  "2026-06-06",
        "month":  "6月",
        "day":  "06",
        "weekday":  "土",
        "name":  "備後国府まつり 花火大会",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "府中市/府中市立府中学園",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-06",
        "dateText":  "2026-06-06",
        "month":  "6月",
        "day":  "06",
        "weekday":  "土",
        "name":  "豊田のホタル祭り",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "下関市/ラピール・ゆめマート豊田店駐車場",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-06",
        "dateText":  "2026-06-06",
        "month":  "6月",
        "day":  "06",
        "weekday":  "土",
        "name":  "OSAKA BAY SKYLUMINA FIREWORKS \u0026 DRONES 2026",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "大阪市此花区/舞洲スポーツアイランド 空の広場",
        "scale":  "約10,000発",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-06",
        "dateText":  "2026-06-06",
        "month":  "6月",
        "day":  "06",
        "weekday":  "土",
        "name":  "りんくう花火2026(ENJOY！りんくう)",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "泉佐野市/りんくうマーブルビーチ、りんくうプレミアムアウトレットシーサイドパーク",
        "scale":  "7000発",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-12",
        "dateText":  "2026-06-12",
        "month":  "6月",
        "day":  "12",
        "weekday":  "金",
        "name":  "第42回 咲花温泉水中花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "五泉市/五泉市佐取地内阿賀野川",
        "scale":  "約200発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-13",
        "dateText":  "2026-06-13",
        "month":  "6月",
        "day":  "13",
        "weekday":  "土",
        "name":  "常滑りんくうビーチ サンセット花火",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "常滑市/常滑りんくう海浜緑地",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-13",
        "dateText":  "2026-06-13",
        "month":  "6月",
        "day":  "13",
        "weekday":  "土",
        "name":  "まき夏まつり 花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "新潟市西蒲区/矢川ふれあい公園",
        "scale":  "約200発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-13",
        "dateText":  "2026-06-13",
        "month":  "6月",
        "day":  "13",
        "weekday":  "土",
        "name":  "長岡花火ローズファンタジー",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長岡市/国営越後丘陵公園",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-20",
        "dateText":  "2026-06-20",
        "month":  "6月",
        "day":  "20",
        "weekday":  "土",
        "name":  "第19回 古都ひろさき 花火の集い",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "弘前市/弘前市 岩木川河川敷運動公園",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-20",
        "dateText":  "2026-06-20",
        "month":  "6月",
        "day":  "20",
        "weekday":  "土",
        "name":  "たきの花火2026",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "札幌市南区/国営滝野すずらん丘陵公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-06-27",
        "dateText":  "2026-06-27",
        "month":  "6月",
        "day":  "27",
        "weekday":  "土",
        "name":  "第10回 えべつ花火",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "江別市/江別花火大会会場",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "6月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-01",
        "dateText":  "2026-07-01",
        "month":  "7月",
        "day":  "01",
        "weekday":  "水",
        "name":  "東京競馬場花火2026 『SHOGO HAMADA　50th ANNIVERSARY FIREWORKS 2026 　FLASH AND SHADOW ～ 光と影の季節 ～』",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "府中市/JRA東京競馬場",
        "scale":  "1万4000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-04",
        "dateText":  "2026-07-04",
        "month":  "7月",
        "day":  "04",
        "weekday":  "土",
        "name":  "ふじおかおいでん夏まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊田市/藤岡コミュニティ広場",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-04",
        "dateText":  "2026-07-04",
        "month":  "7月",
        "day":  "04",
        "weekday":  "土",
        "name":  "海洋博美ら海花火大会2026",
        "prefecture":  "沖縄県",
        "area":  "okinawa",
        "areaLabel":  "沖縄",
        "venue":  "国頭郡本部町/国営沖縄記念公園(海洋博公園)・エメラルドビーチ",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "沖縄県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-04",
        "dateText":  "2026-07-04",
        "month":  "7月",
        "day":  "04",
        "weekday":  "土",
        "name":  "御田祭の里花火大会",
        "prefecture":  "宮崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "東臼杵郡美郷町/葉桜ふれあい公園",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "宮崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-04",
        "dateText":  "2026-07-04",
        "month":  "7月",
        "day":  "04",
        "weekday":  "土",
        "name":  "富士山・河口湖山開き花火大会",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡富士河口湖町/大池公園",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-04",
        "dateText":  "2026-07-04",
        "month":  "7月",
        "day":  "04",
        "weekday":  "土",
        "name":  "第42回 協和七夕花火",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "大仙市/秋田県大仙市協和船岡庄内地区",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-04",
        "dateText":  "2026-07-04",
        "month":  "7月",
        "day":  "04",
        "weekday":  "土",
        "name":  "舟見七夕花火",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "下新川郡入善町/舟見地区",
        "scale":  "約1200発",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-10",
        "dateText":  "2026-07-10",
        "month":  "7月",
        "day":  "10",
        "weekday":  "金",
        "name":  "2026年鎌倉花火大会(第78回)",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "鎌倉市/由比ヶ浜海岸・材木座海岸",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "ぎおん・野島祭り花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "知多郡南知多町/篠島漁港沖堤",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "日間賀島ぎおん祭り花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "知多郡南知多町/日間賀島西浜海水浴場",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "第28回 阿字ヶ浦海岸花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "ひたちなか市/阿字ヶ浦海岸",
        "scale":  "約75発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "2026 久里浜ペリー祭花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "横須賀市/久里浜海岸付近",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "第33回 ジャックドまつり",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "三戸郡南部町/南部町ふれあい公園",
        "scale":  "1800発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "令和8年度 篠栗祇園夏まつり 納涼花火大会",
        "prefecture":  "福岡県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "糟屋郡篠栗町/篠栗町上町",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "福岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "T×T GARAGE(ティーバイティーガレージ) 第14回 真駒内花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "札幌市南区/真駒内セキスイハイムスタジアム",
        "scale":  "2万2000発(予定)",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "WE LOVE HOKKAIDO＆FIGHTERSシリーズ 花火大会 Supported by ビックカメラ",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "北広島市/エスコンフィールドHOKKAIDO",
        "scale":  "6000発超",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-11",
        "dateText":  "2026-07-11",
        "month":  "7月",
        "day":  "11",
        "weekday":  "土",
        "name":  "第47回 くんねっぷふるさとまつり 花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "常呂郡訓子府町/常呂川河川敷",
        "scale":  "約210発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-12",
        "dateText":  "2026-07-12",
        "month":  "7月",
        "day":  "12",
        "weekday":  "日",
        "name":  "第5回 芽室花火大会「華音2026」",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "河西郡芽室町/芽室公園",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-16",
        "dateText":  "2026-07-16",
        "month":  "7月",
        "day":  "16",
        "weekday":  "木",
        "name":  "しおざわ夏まつり 花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南魚沼市/塩沢中学校裏魚野川周辺",
        "scale":  "約250発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-17",
        "dateText":  "2026-07-17",
        "month":  "7月",
        "day":  "17",
        "weekday":  "金",
        "name":  "豊橋祇園祭",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊橋市/吉田神社境内、豊川河畔",
        "scale":  "約1万2000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-17",
        "dateText":  "2026-07-17",
        "month":  "7月",
        "day":  "17",
        "weekday":  "金",
        "name":  "豊川夏まつり「豊川進雄神社例大祭」",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊川市/豊川進雄神社境内、社務所前",
        "scale":  "約300発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "気まぐれクック・東海オンエア虫眼鏡・うお一番 presents 第36回 豊浜花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "知多郡南知多町/豊浜漁港埋立地周辺",
        "scale":  "3500発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "大足区祭礼(大足蛇車まつり)",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "知多郡武豊町/豊石神社境内",
        "scale":  "約500発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "かわのえ夏まつり花火大会",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "四国中央市/川之江港防波堤",
        "scale":  "約3500発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "2026 岡山国際サーキット花火大会 produced by 磯谷煙火店",
        "prefecture":  "岡山県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "美作市/岡山国際サーキット",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "岡山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "油津港まつり2026 花火大会",
        "prefecture":  "宮崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "日南市/油津港周辺",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "宮崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "海の京都 みやづBAY花火2026",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "宮津市/京都府宮津市字文珠天橋公園内",
        "scale":  "75発～150発",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "雲仙天草国立公園天草地域指定70周年 第38回苓北じゃっと祭 花火大会",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "天草郡苓北町/富岡港船客待合所横防波堤",
        "scale":  "約700発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "2026宮島さん協賛いんのしま水軍花火大会",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "尾道市/土生港周辺",
        "scale":  "非公表",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "沼田本郷夏まつり",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "三原市/本郷大橋下流沼田川右岸",
        "scale":  "2026発",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第61回 かんおんじ銭形まつり",
        "prefecture":  "香川県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "観音寺市/財田川河口(琴弾廻廊裏)",
        "scale":  "4500発",
        "status":  "予定",
        "tags":  [
                     "香川県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第74回 伊勢神宮奉納全国花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊勢市/三重県伊勢市　宮川河畔(度会橋上流)",
        "scale":  "約8400発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "ながと花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "長門市/湊魚市場",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第32回 上関水軍まつり 花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "熊毛郡上関町/上関大橋周辺",
        "scale":  "1500発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第22回 港まつり 能代の花火",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "能代市/能代港下浜ふ頭特設会場",
        "scale":  "1万5000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第40回日本海洋上花火大会",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "由利本荘市/道川漁港海上",
        "scale":  "約1500発(予定)",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "愛宕山手筒花火",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "磐田市/東坂町愛宕神社境内",
        "scale":  "約60本",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第73回 安倍川花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "静岡市葵区/安倍川河川敷(田町三丁目付近)",
        "scale":  "1万～1万5000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "マリンフェスタinくちのつ 2026",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "南島原市/口之津港緑地公園",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第40回  にまごいせ祭",
        "prefecture":  "島根県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "大田市/仁摩健康公園内仁摩サンドミュージアム周辺",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "島根県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "Retra！水都祭2026",
        "prefecture":  "徳島県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "徳島市/藍場浜公園",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "徳島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "新宮納涼ふれあいまつり＆花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "たつの市/新宮宮内遺跡公園周辺",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "姫祭夏花火2026",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "姫路市/姫路セントラルパーク",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "第73回 北見ぼんちまつり納涼花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "北見市/春光町・小泉河川敷地",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-18",
        "dateText":  "2026-07-18",
        "month":  "7月",
        "day":  "18",
        "weekday":  "土",
        "name":  "南紀白浜温泉 2026年メッセージ花火",
        "prefecture":  "和歌山県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "西牟婁郡白浜町/白良浜海岸",
        "scale":  "50",
        "status":  "予定",
        "tags":  [
                     "和歌山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "第79回 塩竈みなと祭前夜祭花火大会",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "塩竈市/塩釜港周辺",
        "scale":  "約8000発(予定)",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "さのよいファイヤーカーニバル2026",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "荒尾市/グリーンランド (遊園地)",
        "scale":  "1万発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "第31回 さざ波フェスタ2026",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "天草市/四郎ヶ浜ビーチ沖",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "伊賀市市民花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊賀市/上野運動公園",
        "scale":  "1500発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "第58回 見附まつり花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "見附市/見附運動公園多目的グラウンド内特設会場",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "戸倉上山田温泉夏祭りと煙火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "千曲市/戸倉上山田温泉",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "第39回須坂みんなの花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "須坂市/百々川緑地公園",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "小松島港まつり納涼花火大会",
        "prefecture":  "徳島県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "小松島市/小松島町新港地区一帯",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "徳島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "ふるさと龍宮まつり海上花火大会",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "滑川市/富山湾(ほたるいかミュージアム周辺)",
        "scale":  "約600発",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "もとみや みずいろ花火",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "本宮市/阿武隈川河川敷",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "浜坂ふるさと夏祭り 花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "美方郡新温泉町/浜坂県民サンビーチ",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "函館新聞社第27回函館港花火大会 ～海の日制定記念",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "函館市/緑の島",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-19",
        "dateText":  "2026-07-19",
        "month":  "7月",
        "day":  "19",
        "weekday":  "日",
        "name":  "スターライトイリュージョン2026",
        "prefecture":  "和歌山県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "和歌山市/和歌山マリーナシティ 西側防波堤",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "和歌山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-20",
        "dateText":  "2026-07-20",
        "month":  "7月",
        "day":  "20",
        "weekday":  "月",
        "name":  "ダイワロイネットホテルズpresents 第11回楽天イーグルス花火大会",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "仙台市宮城野区/楽天モバイルパーク宮城",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-20",
        "dateText":  "2026-07-20",
        "month":  "7月",
        "day":  "20",
        "weekday":  "月",
        "name":  "石和温泉鵜飼花火",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "笛吹市/笛吹市役所本館前笛吹川河川敷",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-20",
        "dateText":  "2026-07-20",
        "month":  "7月",
        "day":  "20",
        "weekday":  "月",
        "name":  "夏季熱海海上花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "熱海市/熱海湾(熱海港7.5m岸壁～海釣り施設)",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-20",
        "dateText":  "2026-07-20",
        "month":  "7月",
        "day":  "20",
        "weekday":  "月",
        "name":  "きすき夏まつり",
        "prefecture":  "島根県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "雲南市/斐伊川河川敷",
        "scale":  "1500発",
        "status":  "予定",
        "tags":  [
                     "島根県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-22",
        "dateText":  "2026-07-22",
        "month":  "7月",
        "day":  "22",
        "weekday":  "水",
        "name":  "第60回 うわじま牛鬼まつり海上打上花火",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "宇和島市/宇和島湾",
        "scale":  "約7000",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-22",
        "dateText":  "2026-07-22",
        "month":  "7月",
        "day":  "22",
        "weekday":  "水",
        "name":  "令和8年度入間基地納涼祭～盆踊りと花火の夕べ～",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "狭山市/航空自衛隊入間基地",
        "scale":  "約900発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-23",
        "dateText":  "2026-07-23",
        "month":  "7月",
        "day":  "23",
        "weekday":  "木",
        "name":  "愛宕山花火祭大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "郡上市/岐阜県郡上市美並町白山地内",
        "scale":  "200発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-23",
        "dateText":  "2026-07-23",
        "month":  "7月",
        "day":  "23",
        "weekday":  "木",
        "name":  "第24回 大津志賀花火大会",
        "prefecture":  "滋賀県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "大津市/近江舞子中浜水泳場一帯",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "滋賀県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-24",
        "dateText":  "2026-07-24",
        "month":  "7月",
        "day":  "24",
        "weekday":  "金",
        "name":  "浜玉町 花火大会",
        "prefecture":  "佐賀県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "唐津市/浜崎海岸",
        "scale":  "1300発",
        "status":  "予定",
        "tags":  [
                     "佐賀県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-24",
        "dateText":  "2026-07-24",
        "month":  "7月",
        "day":  "24",
        "weekday":  "金",
        "name":  "第71回鳥羽みなとまつり",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "鳥羽市/鳥羽湾上",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-24",
        "dateText":  "2026-07-24",
        "month":  "7月",
        "day":  "24",
        "weekday":  "金",
        "name":  "伊東温泉「夢花火」Part1～6・8～9",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/伊東海岸",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-24",
        "dateText":  "2026-07-24",
        "month":  "7月",
        "day":  "24",
        "weekday":  "金",
        "name":  "第59回 堂ヶ島火祭り",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "賀茂郡西伊豆町/賀茂郡西伊豆町仁科　堂ヶ島公園",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-24",
        "dateText":  "2026-07-24",
        "month":  "7月",
        "day":  "24",
        "weekday":  "金",
        "name":  "諏訪湖サマーナイト花火2026",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "諏訪市/上諏訪温泉諏訪湖上",
        "scale":  "約500発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-24",
        "dateText":  "2026-07-24",
        "month":  "7月",
        "day":  "24",
        "weekday":  "金",
        "name":  "第80回 むろらん港まつり 納涼花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "室蘭市/室蘭中央埠頭",
        "scale":  "約2200発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "2026 にゅうがわ花火大会",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "西条市/壬生川駅正面線",
        "scale":  "約6000発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "風早海まつり",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "松山市/北条外港野積場",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第66回 水戸黄門まつり 水戸偕楽園花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "水戸市/千波公園",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第80回 落合納涼花火大会",
        "prefecture":  "岡山県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "真庭市/旧真庭市役所落合振興局跡地前 旭川河川敷",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "岡山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第53回 恵那納涼水上花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "恵那市/恵那峡",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "南三陸町志津川湾夏まつり",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "本吉郡南三陸町/志津川仮設魚市場特設会場",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "あやべ水無月まつり",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "綾部市/川糸町由良川周辺",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "間人みなと祭",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "京丹後市/丹後町間人・間人港周辺",
        "scale":  "約800発",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "天草ほんど花火大会",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "天草市/本渡港",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第27回 館林手筒花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "館林市/館林城ゆめひろば",
        "scale":  "1073発(手筒花火73発、打ち上げ花火1000発)",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "おのみち住吉花火まつり",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "尾道市/住吉神社地先尾道水道海上",
        "scale":  "約1万3000発",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "広島みなと 夢 花火大会～花火ミュージアム～",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "広島市南区/広島港1万トンバース(広島市南区)",
        "scale":  "1万発",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第78回 小川町七夕まつり",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "比企郡小川町/小川町駅周辺",
        "scale":  "約220発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "令8年度 さいたま市花火大会 大和田公園会場",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "さいたま市北区/大和田公園周辺",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "2026 きほく燈籠祭",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "北牟婁郡紀北町/紀北町 長島港",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "夏の鳥羽湾毎夜連続花火",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "鳥羽市/佐田浜、安楽島湾、小浜湾",
        "scale":  "約100発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "桑名水郷花火大会 2026",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "桑名市/揖斐川河畔(鍋屋堤)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "志摩スペイン村 ナイトパレード＆花火",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "志摩市/志摩スペイン村",
        "scale":  "約140発(各日)",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "大淀祇園祭と花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "多気郡明和町/大淀漁港一帯",
        "scale":  "約6000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "津市合併20周年第73回津花火大会2026",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "津市/津市阿漕浦海岸",
        "scale":  "5000発以上",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "名張川納涼花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "名張市/名張川左岸(名張市黒田地内)",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "光花火大会「#虹はなび」",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "光市/光市虹ヶ浜海水浴場一帯",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第59回 菊川夏まつり花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "下関市/菊川ふれあい会館広場周辺",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第72回 宇部市花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "宇部市/宇部港内",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第94回厚狭花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "山陽小野田市/厚狭川河畔",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第67回 笛吹川県下納涼花火大会",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "山梨市/笛吹川万力大橋下流",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "甲賀流にんにん大花火2026",
        "prefecture":  "滋賀県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "甲賀市/野洲川河川敷",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "滋賀県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "たざわ湖・龍神まつり たざわ湖花火",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "仙北市/田沢湖",
        "scale":  "約300発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "みたねサンドクラフト2026",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "山本郡三種町/釜谷浜海水浴場",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第74回 本荘川まつり花火大会",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "由利本荘市/友水公園(ボートプラザアクアパル前河川敷)",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "糸魚川大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "糸魚川市/青海シーサイドパーク",
        "scale":  "約800発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "未来へつなぐ川口まつり大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長岡市/魚野川河川敷",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "弥彦燈籠まつり 奉納花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "西蒲原郡弥彦村/弥彦公園",
        "scale":  "約200発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第57回 東北町湖水まつり花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "上北郡東北町/小川原公園内湖水浴場",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "新居諏訪神社奉納煙火祭礼",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "湖西市/静岡県湖西市新居中学校グラウンド",
        "scale":  "1000本",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "全国花火名人選抜競技大会 ふくろい遠州の花火2026",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "袋井市/袋井市原野谷川親水公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第57回 熱川海上花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "賀茂郡東伊豆町/熱川海岸堤防",
        "scale":  "約800発(予定)",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第58回伊豆白浜海の祭典",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "下田市/白浜大浜海水浴場",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第62回 富士山金太郎夏まつり",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "駿東郡小山町/小山町総合文化会館",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第79回 沼津夏まつり・狩野川花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "沼津市/狩野川河川敷(永代橋～御成橋～あゆみ橋)",
        "scale":  "約1万2000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "「東京湾口道路建設促進」第11回 富津市民花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "富津市/富津海水浴場",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "市制施行20周年記念  山武市サマーカーニバル",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "山武市/蓮沼海浜公園展望塔前広場",
        "scale":  "1500～2000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "天神祭奉納花火",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "大阪市北区/川崎公園・桜之宮公園",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "2026ながさきみなとまつり",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "長崎市/長崎港、長崎水辺の森公園",
        "scale":  "1万発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "疫神社夏祭り今福花火大会",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "松浦市/今福町浦免今福港堤防～疫神社周辺",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "令和8年 ありかわ縁日 花火大会",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "南松浦郡新上五島町/有川港堤防",
        "scale":  "約450発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "諫早万灯川まつり",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "諫早市/公園橋下河川敷",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第102回 野尻湖花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "上水内郡信濃町/野尻湖上",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第30回 村民夏まつり",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "下伊那郡泰阜村/泰阜村総合グラウンド",
        "scale":  "約400発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第49回 隅田川花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "墨田区/桜橋下流～言問橋上流(第一会場)、駒形橋下流～厩橋上流(第二会場)",
        "scale":  "約2万発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "立川まつり 国営昭和記念公園花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "立川市/国営昭和記念公園",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第54回 真岡市夏祭大花火大会",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "真岡市/真岡市役所東側五行川沿い",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "水橋橋まつり",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "富山市/白岩川河畔",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第40回 くろべ生地浜海上花火大会",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "黒部市/生地浜海岸",
        "scale":  "1500発",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "あしや花火大会2026",
        "prefecture":  "福岡県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "遠賀郡芦屋町/遠賀川河口一帯",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "福岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第48回 ふくしま花火大会〜光で紡ぐ感謝と挑戦 ともに未来へ〜",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "福島市/信夫ケ丘緑地",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第49回 香住ふるさとまつり海上花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "美方郡香美町/香住浜(しおかぜ香苑)沖合",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "ルスツリゾート夏休みスペシャル花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "虻田郡留寿都村/ルスツリゾート敷地内サンサンフィールド付近",
        "scale":  "1200発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "千歳市空港開港100年記念 千歳市民花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "千歳市/北千歳駐屯地内 スキー山",
        "scale":  "約2800発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第39回 つきがた夏まつり",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "樺戸郡月形町/皆楽公園",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第64回 層雲峡温泉 峡谷火まつり",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "上川郡上川町/層雲峡温泉層雲峡園地",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第72回 もんべつ港まつり オホーツク花火の祭典",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "紋別市/紋別港第1ふ頭前",
        "scale":  "7000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第78回 あばしりオホーツク夏まつり花火大会「網走花火」",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "網走市/西防波堤・帽子岩(網走道の駅流氷街道網走の対岸)",
        "scale":  "1万2000発超",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-25",
        "dateText":  "2026-07-25",
        "month":  "7月",
        "day":  "25",
        "weekday":  "土",
        "name":  "第74回 港まつり花火大会",
        "prefecture":  "和歌山県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "和歌山市/和歌山港中埠頭沖合",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "和歌山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "2026 第44回蒲郡まつり納涼花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "蒲郡市/蒲郡市内",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第58回 豊田おいでんまつり花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊田市/白浜公園一帯",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第14回 伊予彩まつり 花火大会",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "伊予市/伊予港防波堤",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "町制施行100周年記念 第59回 おながわみなと祭り",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "牡鹿郡女川町/女川町海岸広場",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "みなと舞鶴ちゃった花火大会2026",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "舞鶴市/東地区海岸",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第20回 香南市みなこい港まつり",
        "prefecture":  "高知県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "香南市/吉川漁港堤防",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "高知県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "ぎおん柏崎まつり 海の大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "柏崎市/柏崎市中央海岸・みなとまち海浜公園一帯",
        "scale":  "約1万6000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "上越まつり大花火大会(直江津地区)",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "上越市/関川河口",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第140回 鉱山祭・花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "佐渡市/相川浜公園",
        "scale":  "約500発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "べっぷ火の海まつり 納涼花火大会",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "別府市/別府スパビーチ沖",
        "scale":  "8888発",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第27回 ななせの火群まつり",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "大分市/七瀬川自然公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第60回 富山新港花火大会",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "射水市/海王丸パーク",
        "scale":  "2000発以上",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "のおがた夏まつり 2026",
        "prefecture":  "福岡県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "直方市/直方市役所下(直方リバーサイドパーク)",
        "scale":  "約6000発",
        "status":  "予定",
        "tags":  [
                     "福岡県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第117回 大沼湖水まつり 花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "亀田郡七飯町/大沼公園広場",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-26",
        "dateText":  "2026-07-26",
        "month":  "7月",
        "day":  "26",
        "weekday":  "日",
        "name":  "第60回 おたる潮まつり 大花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "小樽市/小樽港第3号ふ頭基部",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-27",
        "dateText":  "2026-07-27",
        "month":  "7月",
        "day":  "27",
        "weekday":  "月",
        "name":  "波止のまつり納涼花火大会",
        "prefecture":  "鳥取県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "東伯郡琴浦町/琴浦町赤碕菊港周辺",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "鳥取県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-28",
        "dateText":  "2026-07-28",
        "month":  "7月",
        "day":  "28",
        "weekday":  "火",
        "name":  "須佐湾大花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "萩市/須佐漁港",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-28",
        "dateText":  "2026-07-28",
        "month":  "7月",
        "day":  "28",
        "weekday":  "火",
        "name":  "第60回 葛飾納涼花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "葛飾区/葛飾区柴又野球場(江戸川河川敷)",
        "scale":  "約2万発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-29",
        "dateText":  "2026-07-29",
        "month":  "7月",
        "day":  "29",
        "weekday":  "水",
        "name":  "鴨川市民花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "鴨川市/前原横渚海岸",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-30",
        "dateText":  "2026-07-30",
        "month":  "7月",
        "day":  "30",
        "weekday":  "木",
        "name":  "佐賀関納涼花火大会　関の権現早吸日女神社 夏祭り",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "大分市/金山港",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-30",
        "dateText":  "2026-07-30",
        "month":  "7月",
        "day":  "30",
        "weekday":  "木",
        "name":  "御蔵島花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "御蔵島村/御蔵島港",
        "scale":  "約802発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-30",
        "dateText":  "2026-07-30",
        "month":  "7月",
        "day":  "30",
        "weekday":  "木",
        "name":  "城崎温泉夏物語「夢花火」",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "豊岡市/城崎温泉街",
        "scale":  "約200発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-30",
        "dateText":  "2026-07-30",
        "month":  "7月",
        "day":  "30",
        "weekday":  "木",
        "name":  "第54回 たけの海上花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "豊岡市/竹野浜海水浴場",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-31",
        "dateText":  "2026-07-31",
        "month":  "7月",
        "day":  "31",
        "weekday":  "金",
        "name":  "第69回 にいはま納涼花火大会",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "新居浜市/国領川河川敷平形橋北側",
        "scale":  "8000発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-31",
        "dateText":  "2026-07-31",
        "month":  "7月",
        "day":  "31",
        "weekday":  "金",
        "name":  "第63回  奄美まつり花火大会",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "奄美市/名瀬商港区",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-31",
        "dateText":  "2026-07-31",
        "month":  "7月",
        "day":  "31",
        "weekday":  "金",
        "name":  "SBI舞花火 in 堺大魚夜市",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "堺市堺区/堺旧港",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-07-31",
        "dateText":  "2026-07-31",
        "month":  "7月",
        "day":  "31",
        "weekday":  "金",
        "name":  "第73回 福井フェニックス花火",
        "prefecture":  "福井県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "福井市/足羽川河川敷(木田橋～板垣橋)",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "福井県",
                     "7月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "御油夏まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊川市/東三河ふるさと公園周辺　音羽川河畔",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "打上花火「スプラッシュGIGA MAX」",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "蒲郡市/ラグーナテンボス ラグナシア",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "八坂神社祭典",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "北設楽郡東栄町/東栄町大字下田字市場周辺",
        "scale":  "非公表",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "ながはま赤橋夏まつり",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "大洲市/長浜港湾緑地",
        "scale":  "1800発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第74回 松山港まつり・三津浜花火大会",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "松山市/三津ふ頭",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "ひたち河原子花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "日立市/河原子港",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第21回 古河花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "古河市/古河ゴルフリンクス",
        "scale":  "非公表",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "三陸・大船渡夏まつり 花火大会",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "大船渡市/みなと公園",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "いびがわの祭り「ありがとう花火」",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "揖斐郡揖斐川町/揖斐川河川敷　前島橋上流",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "飛騨高山市民花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "高山市/アルプス展望公園スカイパーク周辺",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "美濃市民花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "美濃市/下渡橋下流 長良川河畔",
        "scale":  "約1000発(予定)",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第78回 みやざき納涼花火大会",
        "prefecture":  "宮崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "宮崎市/大淀川河畔",
        "scale":  "1万発以上",
        "status":  "予定",
        "tags":  [
                     "宮崎県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第42回 つまごい祭",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "吾妻郡嬬恋村/嬬恋村立東部小学校校庭対岸・吾妻川河川敷右岸",
        "scale":  "約1800発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第55回 たどつ港まつり花火大会",
        "prefecture":  "香川県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "仲多度郡多度津町/多度津港",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "香川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第64回 市民祭あしずりまつり",
        "prefecture":  "高知県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "土佐清水市/清水港(鹿島周辺)",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "高知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第67回 須崎まつり海上花火大会",
        "prefecture":  "高知県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "須崎市/須崎市　富士ヶ浜",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "高知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "寄居玉淀水天宮祭花火大会",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "大里郡寄居町/寄居町玉淀河原",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "市制施行60周年記念 第73回戸田橋花火大会",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "戸田市/国道17号戸田橋上流荒川河川敷",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "朝霞市民まつり「彩夏祭」",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "朝霞市/キャンプ朝霞跡地",
        "scale":  "約9000発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第73回 おわせ港まつり",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "尾鷲市/尾鷲港周辺",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "津市合併20周年 第65回 久居花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "津市/陸上自衛隊久居駐屯地グラウンド",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第50回 サンフェスタしんなんよう",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "周南市/JR新南陽駅周辺",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "山中湖「報湖祭」花火大会",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡山中湖村/山中湖畔",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "湖南市夏まつり2026",
        "prefecture":  "滋賀県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "湖南市/野洲川親水公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "滋賀県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "いちき串木野サマーフェスタ2026～いちき串木野花火大会～",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "いちき串木野市/市来ふれあい温泉センター西側河川敷",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第22回 三条夏まつり大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "三条市/上須頃堤外地",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第37回 小田原酒匂川花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "小田原市/酒匂川スポーツ広場",
        "scale":  "非公表",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第52回 サザンビーチちがさき花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "茅ヶ崎市/サザンビーチちがさき(茅ヶ崎海水浴場)",
        "scale":  "2000発(予定)",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第74回 さがみ湖湖上祭花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "相模原市緑区/相模湖上",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "きにゃんね大仁夏祭り",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊豆の国市/狩野川大仁橋下流河川敷",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "御前崎みなと夏祭・花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "御前崎市/マリンパーク御前崎",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "佐鳴湖花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "浜松市中央区/佐鳴湖西岸 公園時計台付近",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "鹿島の花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "浜松市天竜区/天竜川河川敷",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第39回 大井川大花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "島田市/JR東海道本線「大井川鉄橋」と県道島田岡部線「大井川橋」の間の河川敷",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "片山津温泉納涼花火まつり",
        "prefecture":  "石川県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "加賀市/片山津温泉 柴山潟湖上",
        "scale":  "約200発",
        "status":  "予定",
        "tags":  [
                     "石川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "一宮町納涼花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "長生郡一宮町/一宮海岸",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "九十九里町ふるさとまつり 花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "山武郡九十九里町/片貝中央海岸(ふるさと自然公園内)",
        "scale":  "2500発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "手賀沼花火大会2026",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "柏市/我孫子市・手賀沼",
        "scale":  "約1万3500発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "松戸花火大会2026",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "松戸市/古ヶ崎河川敷スポーツ広場",
        "scale":  "1万2000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "千葉開府900年記念 幕張ビーチ花火フェスタ2026(第48回 千葉市民花火大会)",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "千葉市美浜区/幕張海浜公園、幕張メッセ駐車場(千葉市美浜区)",
        "scale":  "約2万4000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第127回 水郷おみがわ花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "香取市/小見川大橋下流 利根川河畔",
        "scale":  "約5000～7000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第42回 市川市民納涼花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "市川市/江戸川河川敷",
        "scale":  "約1万4000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "令和8年 習志野駐屯地夏まつり",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "船橋市/陸上自衛隊習志野駐屯地敷地内",
        "scale":  "約850発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "連夜の花火 IN 天津小湊",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "鴨川市/小湊漁港",
        "scale":  "約150発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "桜まつりサマーブロッサムナイトin狭山池2026",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "大阪狭山市/狭山池公園",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第74回 おおむら夏越花火大会",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "大村市/ボートレース大村沖",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第42回 真田まつり2026 夏の陣「真田三代花火」",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "上田市/真田運動公園グラウンド周辺",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "2026松江水郷祭 湖上花火大会",
        "prefecture":  "島根県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "松江市/宍道湖東側湖上",
        "scale":  "8月1日(土)1万発、8月2日(日)1万1000発",
        "status":  "予定",
        "tags":  [
                     "島根県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第51回 江戸川区花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "江戸川区/江戸川河川敷(都立篠崎公園先)",
        "scale":  "約1万4000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第67回 いたばし花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "板橋区/ 板橋区 荒川河川敷",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "八王子花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "八王子市/富士森公園",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第110回 足利花火大会",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "足利市/渡良瀬川田中橋下流河川敷",
        "scale":  "約2万発",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "百華繚乱花火～鬼怒川焔火～",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "日光市/鬼怒川温泉郷 鬼怒楯岩大吊橋",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "若狭マリンピア2026",
        "prefecture":  "福井県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "小浜市/小浜湾",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "福井県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "若狭高浜花火大会",
        "prefecture":  "福井県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "大飯郡高浜町/東部海岸(若狭和田ビーチ～城山海水浴場)",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "福井県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第71回 いわき花火大会",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "いわき市/アクアマリンパーク(小名浜港1・2号埠頭)",
        "scale":  "1万2000発",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第48回 芦屋サマーカーニバル",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "芦屋市/潮芦屋ビーチ",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "おこっぺ夏まつり",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "紋別郡興部町/道の駅 おこっぺ",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "めまんべつ観光夏まつり 水上花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "網走郡大空町/網走湖女満別湖畔",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "十勝港まつり「十勝港海上花火大会」",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "広尾郡広尾町/十勝港第4埠頭",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第43回 なかふらのラベンダーまつり＆花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "空知郡中富良野町/北星山ラベンダー園/なかふらのフラワーパーク",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第46回 小さなふるさとづくり「七夕の夕べ」花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "虻田郡ニセコ町/ニセコ町運動公園",
        "scale":  "約1500発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "第49回 恵庭三四会 納涼花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "恵庭市/恵庭市桜町多目的広場",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "函館開港167周年記念 函館港まつり協賛 第71回 道新花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "函館市/緑の島",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-01",
        "dateText":  "2026-08-01",
        "month":  "8月",
        "day":  "01",
        "weekday":  "土",
        "name":  "紀の川橋本SUMMERBALL2026",
        "prefecture":  "和歌山県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "橋本市/南馬場緑地広場",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "和歌山県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第75回 大須夏まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "名古屋市中区/大須観音境内",
        "scale":  "約90本",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "豊明夏まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊明市/豊明市文化会館",
        "scale":  "660発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第48回 津山納涼ごんごまつり IN 吉井川",
        "prefecture":  "岡山県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "津山市/吉井川河岸緑地公園",
        "scale":  "6000発",
        "status":  "予定",
        "tags":  [
                     "岡山県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "ふくおかふるさと花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "中津川市/ローマン渓谷オートキャンプ場対岸河川敷",
        "scale":  "約800発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "伊自良サマーフェスティバル",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "山県市/伊自良ふれあい・さわやかドーム周辺、花咲きホール",
        "scale":  "170発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "炎の祭典 第68回 土岐市織部まつり",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "土岐市/土岐川河川敷　浅野河原",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第32回 まほろば夏まつり「まほろば夢花火」",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "黒川郡大和町/大和町総合運動公園(陸上競技場)",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "西湖竜宮祭花火大会",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡富士河口湖町/西湖前浜沖",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第15回北杜ふるさと祭り",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "北杜市/長坂総合スポーツ公園",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "さつま黒潮「きばらん海」枕崎港まつり花火大会",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "枕崎市/枕崎港堤防",
        "scale":  "約1万発(予定)",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第66回 和泊町港まつり",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "大島郡和泊町/和泊港",
        "scale":  "2416発",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "長岡まつり大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長岡市/信濃川河川敷",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "宇佐美夏まつり海上花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/宇佐美海岸",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第77回 清水みなと祭り 海上花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "静岡市清水区/清水港 日の出埠頭",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "厳原港まつり",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "対馬市/厳原港東浜ふ頭",
        "scale":  "約3500発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "倉吉打吹まつり 飛天花火大会",
        "prefecture":  "鳥取県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "倉吉市/飛天夢広場(倉吉大橋周辺河川敷)",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "鳥取県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "佐用町南光ひまわり祭り花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "佐用郡佐用町/南光スポーツ公園(若あゆランド)周辺",
        "scale":  "800発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第49回 加西サイサイまつり",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "加西市/加西市役所駐車場",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "豊岡 柳まつり花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "豊岡市/円山川河川敷",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "第33回 とうま蟠龍まつり",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "上川郡当麻町/当麻町公民館まとまーる前特設会場(当麻町3条東)",
        "scale":  "約120発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-02",
        "dateText":  "2026-08-02",
        "month":  "8月",
        "day":  "02",
        "weekday":  "日",
        "name":  "歴舟川清流まつり・道新花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "広尾郡大樹町/歴舟川大樹橋上流河川敷",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-03",
        "dateText":  "2026-08-03",
        "month":  "8月",
        "day":  "03",
        "weekday":  "月",
        "name":  "大洲川まつり花火",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "大洲市/肱北河原",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-03",
        "dateText":  "2026-08-03",
        "month":  "8月",
        "day":  "03",
        "weekday":  "月",
        "name":  "本栖湖神湖祭",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡富士河口湖町/本栖湖東岸",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-03",
        "dateText":  "2026-08-03",
        "month":  "8月",
        "day":  "03",
        "weekday":  "月",
        "name":  "第75回 五所川原花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "五所川原市/岩木川河川敷(北斗グラウンド)",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-03",
        "dateText":  "2026-08-03",
        "month":  "8月",
        "day":  "03",
        "weekday":  "月",
        "name":  "伊豆長岡温泉花火大会 狩野川まつり",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊豆の国市/狩野川千歳橋付近河川敷",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-03",
        "dateText":  "2026-08-03",
        "month":  "8月",
        "day":  "03",
        "weekday":  "月",
        "name":  "第33回 神津島 渚の花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "神津島村/神津島港(前浜港)の桟橋",
        "scale":  "747発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-04",
        "dateText":  "2026-08-04",
        "month":  "8月",
        "day":  "04",
        "weekday":  "火",
        "name":  "精進湖涼湖祭",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡富士河口湖町/富士五湖精進湖畔北岸",
        "scale":  "300発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-04",
        "dateText":  "2026-08-04",
        "month":  "8月",
        "day":  "04",
        "weekday":  "火",
        "name":  "第44回 天領さん久手花火大会",
        "prefecture":  "島根県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "大田市/大田市久手港",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "島根県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-04",
        "dateText":  "2026-08-04",
        "month":  "8月",
        "day":  "04",
        "weekday":  "火",
        "name":  "第73回 北日本新聞納涼花火(高岡会場)",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "高岡市/庄川高岡大橋上流",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-05",
        "dateText":  "2026-08-05",
        "month":  "8月",
        "day":  "05",
        "weekday":  "水",
        "name":  "第57回 仙台七夕花火祭",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "仙台市青葉区/西公園付近一帯、広瀬川河川区域及び川内地区",
        "scale":  "1万6000発",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-05",
        "dateText":  "2026-08-05",
        "month":  "8月",
        "day":  "05",
        "weekday":  "水",
        "name":  "防府天満宮御誕辰祭 花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "防府市/防府天満宮",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-05",
        "dateText":  "2026-08-05",
        "month":  "8月",
        "day":  "05",
        "weekday":  "水",
        "name":  "河口湖湖上祭",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡富士河口湖町/河口湖畔船津浜",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-06",
        "dateText":  "2026-08-06",
        "month":  "8月",
        "day":  "06",
        "weekday":  "木",
        "name":  "第40回記念大会 2026 びわ湖大花火大会",
        "prefecture":  "滋賀県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "大津市/滋賀県営大津港沖水面一帯",
        "scale":  "約1万2000発(予定)",
        "status":  "予定",
        "tags":  [
                     "滋賀県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "第73回 一関夏まつり磐井川川開き花火大会",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "一関市/磐井川河川公園",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "榛名湖花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "高崎市/榛名湖畔",
        "scale":  "約1500発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "市川三郷町ふるさと夏まつり　第38回「神明の花火大会」",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "西八代郡市川三郷町/三郡橋下流笛吹川河畔",
        "scale":  "約2万発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "寺泊港まつり海上大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長岡市/寺泊港、中央海水浴場",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "第46回 三浦海岸納涼まつり花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "三浦市/三浦海岸",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "青森ねぶた祭協賛 第72回 青森花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "青森市/青森港内(青い海公園、青い海公園西側、新中央埠頭)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-07",
        "dateText":  "2026-08-07",
        "month":  "8月",
        "day":  "07",
        "weekday":  "金",
        "name":  "第95回 信州千曲市千曲川納涼煙火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "千曲市/戸倉上山田温泉千曲川河畔(大正橋～万葉橋間)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "国府夏まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊川市/大社神社",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "宵の明治村「花火競演」",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "犬山市/博物館 明治村内",
        "scale":  "約400発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "大迫力!夏の花火ショー～音楽×光×花火の競演～",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "安城市/安城産業文化公園デンパーク",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第57回 東海まつり花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "東海市/東海市中央町大池公園内",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第48回 東海まつり花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "那珂郡東海村/阿漕ヶ浦公園",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第71回 とりで利根川大花火",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "取手市/取手緑地運動公園",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "イーハトーブフォーラム2026 光と音のページェント 花火ファンタジー",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "花巻市/北上川河川敷(朝日橋～朝日大橋)",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第4回 ぎふ長良川花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "岐阜市/長良川河畔(長良橋～金華橋間)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第37回 新田まつり花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "太田市/新田陸上競技場",
        "scale":  "4000発(予定)",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第70回 前橋花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "前橋市/利根川河畔大渡橋南北河川緑地",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第74回 熊谷花火大会",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "熊谷市/荒川河畔(荒川大橋下流)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "令和8年度 さいたま市花火大会 東浦和 大間木公園会場",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "さいたま市緑区/大間木公園周辺",
        "scale":  "約2500発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第49回 忍野八海祭り",
        "prefecture":  "山梨県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南都留郡忍野村/忍野中学校校庭",
        "scale":  "8888発",
        "status":  "予定",
        "tags":  [
                     "山梨県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "たるみずふれあいフェスタ2026夏祭り",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "垂水市/旧垂水港特設会場",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "花輪ねぷた",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "鹿角市/花輪稲村橋 下流河川敷",
        "scale":  "300発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第49回 雄勝大花火大会",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "湯沢市/役内川河川敷(新万石橋上流)",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "村上市花火大会in清流あらかわ",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "村上市/荒川河川敷",
        "scale":  "約300発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "両津七夕まつり・川開き花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "佐渡市/両津港内防波堤",
        "scale":  "約550発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "按針祭・灯籠の流れ打上花火",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/伊東海岸",
        "scale":  "約800発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "ヤッサ東金祭",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "東金市/東金中央公園",
        "scale":  "約250発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第62回 館山観光まつり館山湾花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "館山市/汐入川河口導流堤・館山湾",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "銚子みなとまつり花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "銚子市/利根川河畔",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第71回 茨木辯天花火大会",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "茨木市/辯天宗冥應寺境内",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第46回 2026 伊豆大島夏まつり花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "大島町/元町港・元町港ロータリー付近",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第49回 奥多摩納涼花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "西多摩郡奥多摩町/愛宕山広場",
        "scale":  "約1000発(予定)",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "2026うつのみや花火大会",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "宇都宮市/宇都宮市道場宿緑地(鬼怒川河川敷)",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第57回 じゃんとこい魚津まつり",
        "prefecture":  "富山県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "魚津市/魚津港",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "富山県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第35回 ふくやま夏祭り",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "郡山市/富久山河川敷多目的広場",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "ファイターズ超花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "北広島市/エスコンフィールドHOKKAIDO",
        "scale":  "6000発超",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-08",
        "dateText":  "2026-08-08",
        "month":  "8月",
        "day":  "08",
        "weekday":  "土",
        "name":  "第53回 いわない怒涛まつり",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "岩内郡岩内町/岩内地方文化センター西側特設会場",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "第29回 今治市民のまつり「おんまく」花火",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "今治市/今治港防波堤",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "第65回 北上・みちのく芸能まつり「トロッコ流しと花火の夕べ」",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "北上市/北上川河畔",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "飛騨高山手筒花火打上げ",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "高山市/高山市宮川弥生橋下流",
        "scale":  "約180本(予定)",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "千日会観光祭",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "京丹後市/久美浜公園(浜公園隣)",
        "scale":  "約1700発",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "第76回 高知市納涼花火大会",
        "prefecture":  "高知県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "高知市/高知市鏡川河畔(みどりの広場)",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "高知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "ムーミン谷の湖上花火大会～夏2026",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "飯能市/ムーミンバレーパーク",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "長島温泉 「花火大競演」",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "桑名市/ナガシマスパーランド",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "新潟まつり花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "新潟市中央区/新潟市中央区信濃川河畔(昭和大橋周辺)",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "按針祭・太鼓の響き打上花火",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/伊東海岸",
        "scale":  "約800発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "第53回 米子がいな祭 花火大会",
        "prefecture":  "鳥取県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "米子市/米子港岸壁",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "鳥取県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-09",
        "dateText":  "2026-08-09",
        "month":  "8月",
        "day":  "09",
        "weekday":  "日",
        "name":  "第51回 福崎夏まつり",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "神崎郡福崎町/福崎町立福崎東中学校",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-10",
        "dateText":  "2026-08-10",
        "month":  "8月",
        "day":  "10",
        "weekday":  "月",
        "name":  "第80回 按針祭 海の花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/伊東海岸一帯",
        "scale":  "約2万発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-10",
        "dateText":  "2026-08-10",
        "month":  "8月",
        "day":  "10",
        "weekday":  "月",
        "name":  "第59回 飯縄火まつり",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長野市/大座法師池",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-10",
        "dateText":  "2026-08-10",
        "month":  "8月",
        "day":  "10",
        "weekday":  "月",
        "name":  "第89回 霊まつり 流灯花火大会",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "河沼郡柳津町/只見川河畔",
        "scale":  "7000発",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "盛岡花火の祭典",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "盛岡市/都南大橋下流 北上川河川敷",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "福知山HANABI2026",
        "prefecture":  "京都府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "福知山市/由良川河川敷",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "京都府",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第24回 東城 遊夏祭",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "庄原市/東城小学校グラウンド",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第61回 さかいで大橋まつり 海上花火大会",
        "prefecture":  "香川県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "坂出市/坂出港中央埠頭",
        "scale":  "5000発",
        "status":  "予定",
        "tags":  [
                     "香川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "鈴鹿サーキット HANABI祭",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "鈴鹿市/鈴鹿サーキット レーシングコース",
        "scale":  "約3500発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "滋賀農業公園ブルーメの丘 ミュージック花火大会2026",
        "prefecture":  "滋賀県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "蒲生郡日野町/滋賀農業公園 ブルーメの丘",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "滋賀県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第58回 かいもん夏祭り",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "指宿市/かいもん山麓ふれあい公園レクリエーション広場付近",
        "scale":  "約1100発",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "「大館大文字まつり」第72回花火大会",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "大館市/長木川河川敷",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "Gotemba Night!! 2026 (ゴテンバナイト!!2026)",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "御殿場市/御殿場プレミアム・アウトレット",
        "scale":  "約400発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第44回 耶馬溪湖畔祭り",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "中津市/大分県中津市",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第25回 八丈島納涼花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "八丈島八丈町/底土港",
        "scale":  "650発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第44回 三国花火",
        "prefecture":  "福井県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "坂井市/三国サンセットビーチ・九頭竜川ボートパーク",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "福井県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-11",
        "dateText":  "2026-08-11",
        "month":  "8月",
        "day":  "11",
        "weekday":  "火",
        "name":  "第17回 那智勝浦町花火大会",
        "prefecture":  "和歌山県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "東牟婁郡那智勝浦町/那智湾(ブルービーチなち)",
        "scale":  "約9000発",
        "status":  "予定",
        "tags":  [
                     "和歌山県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-12",
        "dateText":  "2026-08-12",
        "month":  "8月",
        "day":  "12",
        "weekday":  "水",
        "name":  "たこ祭り",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "知多郡南知多町/日間賀島東浜海水浴場(サンライズビーチ)",
        "scale":  "約800発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-12",
        "dateText":  "2026-08-12",
        "month":  "8月",
        "day":  "12",
        "weekday":  "水",
        "name":  "花火スペクタキュラ「FLAME」(フレイム)",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "蒲郡市/ラグーナテンボス ラグナシア",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-12",
        "dateText":  "2026-08-12",
        "month":  "8月",
        "day":  "12",
        "weekday":  "水",
        "name":  "伊豆多賀温泉海上花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "熱海市/長浜海浜公園　北側防波堤",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "石鳥谷夢まつり",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "花巻市/北上川大正橋公園対岸",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "つけち夢まつり花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "中津川市/付知川中央橋上流",
        "scale":  "約300発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "アジアポートフェスティバル in KANMON 2026 関門海峡花火大会",
        "prefecture":  "山口県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "下関市/岬之町埠頭、あるかぽーと、カモンワーフ、唐戸市場前",
        "scale":  "約1万8000発",
        "status":  "予定",
        "tags":  [
                     "山口県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "鹿町ふるさと夏まつり",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "佐世保市/旧佐世保市役所鹿町支所周辺",
        "scale":  "1200発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "第39回 関門海峡花火大会",
        "prefecture":  "福岡県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "北九州市門司区/北九州市門司区西海岸周辺",
        "scale":  "1万5000発",
        "status":  "予定",
        "tags":  [
                     "福岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "第39回 山崎納涼夏祭り花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "宍粟市/せせらぎ公園多目的広場",
        "scale":  "1300発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "第74回 勝毎花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "帯広市/十勝川河川敷特設会場(十勝大橋下流400メートル付近)",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-13",
        "dateText":  "2026-08-13",
        "month":  "8月",
        "day":  "13",
        "weekday":  "木",
        "name":  "熊野徐福万燈祭 第64回 新宮花火大会",
        "prefecture":  "和歌山県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "新宮市/熊野川河川敷",
        "scale":  "約6000発",
        "status":  "予定",
        "tags":  [
                     "和歌山県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "足助夏まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "豊田市/足助グラウンド",
        "scale":  "約300発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "阿木夏祭り花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "中津川市/阿木地内(花火打ち上げ)、阿木小学校(祭り開催)",
        "scale":  "約600発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "第36回 明智町納涼花火大会",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "恵那市/大正村広場周辺",
        "scale":  "打ち上げ数未定",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "飛騨小坂力持小太郎火まつり",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "下呂市/東上田ダム河畔",
        "scale":  "約200発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "甘楽町花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "甘楽郡甘楽町/甘楽ふれあいの丘",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "合歓の盆 秩父音頭まつり",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "秩父郡皆野町/美の山中腹",
        "scale":  "800発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "第22回 男鹿日本海花火",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "男鹿市/船川港OGAマリンパーク(男鹿みなと市民病院付近)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "第41回 越後加茂川夏祭り 大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "加茂市/加茂川河川敷",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "十和田市夏まつり花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "十和田市/十和田市陸上競技場西側観覧席・官庁街通り歩行者天国地内",
        "scale":  "約2000発(変動する可能性あり)",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "大間町ブルーマリンフェスティバル2026 花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "下北郡大間町/大間港(旧フェリー埠頭)",
        "scale":  "約6000発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "やんもの里花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/八幡野港",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "第4回 信州駒ヶ根花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "駒ヶ根市/天竜大橋周辺",
        "scale":  "約600発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "第71回浅科納涼大花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "佐久市/浅科総合グラウンド",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "吉賀町ふるさと夏祭り",
        "prefecture":  "島根県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "鹿足郡吉賀町/吉賀町柿木 相生橋周辺",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "島根県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "モビリティリゾートもてぎ 花火の祭典",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "芳賀郡茂木町/モビリティリゾートもてぎ",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-14",
        "dateText":  "2026-08-14",
        "month":  "8月",
        "day":  "14",
        "weekday":  "金",
        "name":  "第55回 あさか野夏まつり花火大会",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "郡山市/カルチャーパーク付近",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "「刈谷わんさか祭り2026」花火大会",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "刈谷市/刈谷市総合運動公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "西尾・米津の川まつり",
        "prefecture":  "愛知県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "西尾市/矢作川米津橋下流",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "愛知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "前沢夏まつり 納涼花火大会",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "奥州市/前沢いきいきスポーツランド",
        "scale":  "約3000発(予定)",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "山鹿灯籠まつり 納涼花火大会",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "山鹿市/菊池川河畔",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "福山夏まつり2026 あしだ川花火大会",
        "prefecture":  "広島県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "福山市/芦田川大橋上流",
        "scale":  "約1万6000発",
        "status":  "予定",
        "tags":  [
                     "広島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "長瀞船玉まつり 花火大会",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "秩父郡長瀞町/長瀞岩畳周辺",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "錦花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "度会郡大紀町/錦魚港",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第33回 赤川花火大会",
        "prefecture":  "山形県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "鶴岡市/赤川河畔(羽黒橋～三川橋)",
        "scale":  "約1万2000発",
        "status":  "予定",
        "tags":  [
                     "山形県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第79回 木更津港まつり花火大会",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "木更津市/中の島公園",
        "scale":  "約1万4000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第53回 むさしの里の夕涼み夏の夜まつり　大分合同新聞むさし花火大会",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "国東市/国東市武蔵港沖",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第64回 佐久千曲川大花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "佐久市/千曲川河川敷(佐久大橋～野沢橋間)",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第74回 ろうかく湖とうろう流しと花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長野市/新町橋下流・竹房河原の上流",
        "scale":  "4000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第78回 諏訪湖祭湖上花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "諏訪市/諏訪市湖畔公園前諏訪湖上",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "鳥取しゃんしゃん祭 第73回 市民納涼花火大会",
        "prefecture":  "鳥取県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "鳥取市/千代河原市民スポーツ広場",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "鳥取県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "越前市サマーフェスティバル 花火大会",
        "prefecture":  "福井県",
        "area":  "hokuriku",
        "areaLabel":  "北陸",
        "venue":  "越前市/日野川河川緑地公園",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "福井県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "三笠北海盆おどり納涼花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "三笠市/幾春別川三笠山橋下流周辺",
        "scale":  "約300発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-15",
        "dateText":  "2026-08-15",
        "month":  "8月",
        "day":  "15",
        "weekday":  "土",
        "name":  "第44回 足寄ふるさと盆踊り・両国花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "足寄郡足寄町/利別川河川敷両国橋下流",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第54回 かわさき夏まつり 花火大会「おらが自慢のでっかい花火」",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "一関市/北上川河畔(北上大橋付近)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第61回 奈半利町港まつり",
        "prefecture":  "高知県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "安芸郡奈半利町/奈半利駅前",
        "scale":  "約3500発",
        "status":  "予定",
        "tags":  [
                     "高知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第53回 塩田夏まつり",
        "prefecture":  "佐賀県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "嬉野市/塩田川河川敷周辺",
        "scale":  "約1200発",
        "status":  "予定",
        "tags":  [
                     "佐賀県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "大石田まつり最上川花火大会",
        "prefecture":  "山形県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "北村山郡大石田町/最上川河川敷 大橋下流域",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "山形県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第66回 金山町納涼花火大会",
        "prefecture":  "山形県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "最上郡金山町/金山川河川敷(金山中学校南側)",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "山形県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第42回 ドンパン祭り",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "大仙市/大仙市中仙支所前「ドンパン広場」",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "鶴の舞橋改修工事記念 2026つるたまつり記念花火大会打上",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "北津軽郡鶴田町/津軽富士見湖",
        "scale":  "2500発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "網代温泉海上花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "熱海市/網代港海上",
        "scale":  "2000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "杵築市納涼花火大会",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "杵築市/塩田特設会場(杵築市海浜夢公園)",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "松原湖灯籠流し花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "南佐久郡小海町/松原湖湖上",
        "scale":  "1000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第59回 岡谷花火まつり",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "岡谷市/岡谷湖畔公園 多目的広場",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "飯田時又灯ろう流し花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "飯田市/天竜川時又港",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "2026江の川祭 花火大会",
        "prefecture":  "島根県",
        "area":  "chugoku",
        "areaLabel":  "中国",
        "venue":  "江津市/江の川河口周辺",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "島根県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "浅川の花火",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "石川郡浅川町/浅川町大字滝輪 滝輪郷地内",
        "scale":  "約3300発",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-16",
        "dateText":  "2026-08-16",
        "month":  "8月",
        "day":  "16",
        "weekday":  "日",
        "name":  "第47回 にしわき市・黒田庄夏まつり",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "西脇市/黒田庄グラウンド",
        "scale":  "約400発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-17",
        "dateText":  "2026-08-17",
        "month":  "8月",
        "day":  "17",
        "weekday":  "月",
        "name":  "西条市市民納涼花火大会",
        "prefecture":  "愛媛県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "西条市/加茂川河畔中堤防",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "愛媛県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-17",
        "dateText":  "2026-08-17",
        "month":  "8月",
        "day":  "17",
        "weekday":  "月",
        "name":  "熊野大花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "熊野市/七里御浜海岸",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-18",
        "dateText":  "2026-08-18",
        "month":  "8月",
        "day":  "18",
        "weekday":  "火",
        "name":  "千代田の祭 川せがき",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "邑楽郡千代田町/赤岩地先利根川河畔",
        "scale":  "約5600発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-18",
        "dateText":  "2026-08-18",
        "month":  "8月",
        "day":  "18",
        "weekday":  "火",
        "name":  "土肥サマーフェスティバル海上花火",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊豆市/松原公園前海岸",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-18",
        "dateText":  "2026-08-18",
        "month":  "8月",
        "day":  "18",
        "weekday":  "火",
        "name":  "第103回 市田灯ろう流し大煙火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "下伊那郡高森町/天竜川河畔明神橋付近",
        "scale":  "約1000発(予定)",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-20",
        "dateText":  "2026-08-20",
        "month":  "8月",
        "day":  "20",
        "weekday":  "木",
        "name":  "第57回 津軽花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "南津軽郡藤崎町/平川河畔白鳥ふれあい広場",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-21",
        "dateText":  "2026-08-21",
        "month":  "8月",
        "day":  "21",
        "weekday":  "金",
        "name":  "弘法大師奉納花火大会",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊豆市/修善寺温泉",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "2026 いなしき夏まつり花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "稲敷市/江戸崎総合運動公園周辺",
        "scale":  "約1万発(予定)",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第32回 ひたちなか祭り花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "ひたちなか市/陸上自衛隊勝田駐屯地",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "かみやはぎふるさとまつり",
        "prefecture":  "岐阜県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "恵那市/上矢作町内上矢作グラウンド",
        "scale":  "約1000発",
        "status":  "予定",
        "tags":  [
                     "岐阜県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "みやざき青島国際ビールまつり",
        "prefecture":  "宮崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "宮崎市/こどものくに(ホテル側広場)",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "宮崎県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第44回 泉区民ふるさとまつり",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "仙台市泉区/やまいちサステナパーク七北田公園",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "大阿蘇火の山まつり 花火大会",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "阿蘇市/阿蘇市総合センター多目的広場",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第52回 高崎大花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "高崎市/烏川和田橋上流河川敷",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "津田まつり",
        "prefecture":  "香川県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "さぬき市/津田の松原(県立琴林公園)・津田の松原海水浴場",
        "scale":  "約600発",
        "status":  "予定",
        "tags":  [
                     "香川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "2026 伊奈まつり",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "北足立郡伊奈町/伊奈町制施行記念公園",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "令和8年度 さいたま市花火大会 岩槻文化公園会場",
        "prefecture":  "埼玉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "さいたま市岩槻区/岩槻文化公園",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "埼玉県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第33回 亀山市関宿納涼花火大会",
        "prefecture":  "三重県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "亀山市/三重県亀山市関町木崎　鈴鹿川河川敷(関消防署西側グランド)",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "三重県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "2026にかほの花火",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "にかほ市/象潟海水浴場",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "令和8年度 おぢやまつり 大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "小千谷市/信濃川河川敷(旭橋下流)",
        "scale":  "7000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第52回 金沢まつり 花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "横浜市金沢区/海の公園",
        "scale":  "約3500発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第46回 八戸花火大会",
        "prefecture":  "青森県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "八戸市/八戸館鼻漁港",
        "scale":  "約7000発",
        "status":  "予定",
        "tags":  [
                     "青森県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "伊東温泉夢花火 Part7 箸まつり花火大会(手筒花火)",
        "prefecture":  "静岡県",
        "area":  "tokai",
        "areaLabel":  "東海",
        "venue":  "伊東市/伊東オレンジビーチ中央",
        "scale":  "打ち上げ花火約1500発、手筒花火約40本",
        "status":  "予定",
        "tags":  [
                     "静岡県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "SBI舞花火 in 大阪・泉南",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "泉南市/SENNAN LONG PARK(泉南りんくう公園)",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-22",
        "dateText":  "2026-08-22",
        "month":  "8月",
        "day":  "22",
        "weekday":  "土",
        "name":  "第12回 港 in しらぬか花火大会",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "白糠郡白糠町/白糠漁港特設会場",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-23",
        "dateText":  "2026-08-23",
        "month":  "8月",
        "day":  "23",
        "weekday":  "日",
        "name":  "ダイワロイネットホテルズpresents 夏スタ! フィナーレ花火大会",
        "prefecture":  "宮城県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "仙台市宮城野区/楽天モバイルパーク宮城",
        "scale":  "約2000発",
        "status":  "予定",
        "tags":  [
                     "宮城県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-23",
        "dateText":  "2026-08-23",
        "month":  "8月",
        "day":  "23",
        "weekday":  "日",
        "name":  "第72回 とちお祭大花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長岡市/鳩峰・タカ待場",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "TKU 江津湖花火大会2025",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "熊本市東区/水前寺江津湖公園",
        "scale":  "1万発程度",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "第22回 しまんと市民祭 納涼花火大会",
        "prefecture":  "高知県",
        "area":  "shikoku",
        "areaLabel":  "四国",
        "venue":  "四万十市/赤鉄橋たもと(四万十川河川敷)",
        "scale":  "約6000発",
        "status":  "予定",
        "tags":  [
                     "高知県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "第98回 全国花火競技大会「大曲の花火」",
        "prefecture":  "秋田県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "大仙市/大仙市大曲雄物川河畔(「大曲の花火」公園)",
        "scale":  "約1万8000発",
        "status":  "予定",
        "tags":  [
                     "秋田県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "小木港祭り・花火大会",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "佐渡市/佐渡市小木町小木港湾内",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "おおいた「夢」花火2026",
        "prefecture":  "大分県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "大分市/大分川弁天大橋上流",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "大分県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "上田商工会議所創立130周年記念　第39回 信州上田大花火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "上田市/千曲川河川敷(常田新橋下流(上田市常田1丁目))",
        "scale":  "約8000発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "尊徳夏まつりザ・ファイナル2026 大花火大会",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "真岡市/鬼怒川河川敷緑地公園(砂ケ原橋付近)",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-08-29",
        "dateText":  "2026-08-29",
        "month":  "8月",
        "day":  "29",
        "weekday":  "土",
        "name":  "せきのみやふれあいまつり",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "養父市/関宮コミュニティスポーツセンター周辺",
        "scale":  "500発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "8月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-05",
        "dateText":  "2026-09-05",
        "month":  "9月",
        "day":  "05",
        "weekday":  "土",
        "name":  "第53回 相模原納涼花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "相模原市中央区/相模原市中央区水郷田名 相模川高田橋上流",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-05",
        "dateText":  "2026-09-05",
        "month":  "9月",
        "day":  "05",
        "weekday":  "土",
        "name":  "全国新作花火チャレンジカップ2026",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "諏訪市/長野県諏訪市湖畔公園前諏訪湖上",
        "scale":  "400発×5回(予定)",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-05",
        "dateText":  "2026-09-05",
        "month":  "9月",
        "day":  "05",
        "weekday":  "土",
        "name":  "北海道芸術花火 2026",
        "prefecture":  "北海道",
        "area":  "hokkaido",
        "areaLabel":  "北海道",
        "venue":  "札幌市東区/モエレ沼公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "北海道",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-11",
        "dateText":  "2026-09-11",
        "month":  "9月",
        "day":  "11",
        "weekday":  "金",
        "name":  "片貝まつり(浅原神社 秋季例大祭奉納大煙火)",
        "prefecture":  "新潟県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "小千谷市/片貝町浅原神社裏手",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "新潟県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-12",
        "dateText":  "2026-09-12",
        "month":  "9月",
        "day":  "12",
        "weekday":  "土",
        "name":  "第59回 常総きぬ川花火大会",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "常総市/鬼怒川河畔・橋本運動公園",
        "scale":  "約13,000発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-12",
        "dateText":  "2026-09-12",
        "month":  "9月",
        "day":  "12",
        "weekday":  "土",
        "name":  "第14回 沼田花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "沼田市/沼田市運動公園(住所：沼田市硯田町626)",
        "scale":  "1万発以上",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-12",
        "dateText":  "2026-09-12",
        "month":  "9月",
        "day":  "12",
        "weekday":  "土",
        "name":  "酒田の花火 2026「つなぐ絆、未来に響け一万発」",
        "prefecture":  "山形県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "酒田市/酒田市最上川河川公園",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "山形県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-12",
        "dateText":  "2026-09-12",
        "month":  "9月",
        "day":  "12",
        "weekday":  "土",
        "name":  "第41回 調布花火",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "調布市/調布市多摩川周辺",
        "scale":  "約10,000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-12",
        "dateText":  "2026-09-12",
        "month":  "9月",
        "day":  "12",
        "weekday":  "土",
        "name":  "第1回 相馬花火大会",
        "prefecture":  "福島県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "相馬市/松川浦新漁港",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "福島県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-16",
        "dateText":  "2026-09-16",
        "month":  "9月",
        "day":  "16",
        "weekday":  "水",
        "name":  "長浜・北びわ湖大花火大会 「長浜の陣」",
        "prefecture":  "滋賀県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "長浜市/豊公園",
        "scale":  "非公開",
        "status":  "予定",
        "tags":  [
                     "滋賀県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-20",
        "dateText":  "2026-09-20",
        "month":  "9月",
        "day":  "20",
        "weekday":  "日",
        "name":  "令和8年度 姫路みなと祭海上花火大会",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "姫路市/姫路港(飾磨地区)",
        "scale":  "1万発超",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-25",
        "dateText":  "2026-09-25",
        "month":  "9月",
        "day":  "25",
        "weekday":  "金",
        "name":  "第102回 飯塚納涼花火大会",
        "prefecture":  "福岡県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "飯塚市/遠賀川中之島",
        "scale":  "7000発",
        "status":  "予定",
        "tags":  [
                     "福岡県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-26",
        "dateText":  "2026-09-26",
        "month":  "9月",
        "day":  "26",
        "weekday":  "土",
        "name":  "大洗海上花火大会2026",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "東茨城郡大洗町/大洗サンビーチ",
        "scale":  "約1万8000発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-26",
        "dateText":  "2026-09-26",
        "month":  "9月",
        "day":  "26",
        "weekday":  "土",
        "name":  "おおあみしらさとの花火",
        "prefecture":  "千葉県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "大網白里市/白里海水浴場",
        "scale":  "3000発",
        "status":  "予定",
        "tags":  [
                     "千葉県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-09-27",
        "dateText":  "2026-09-27",
        "month":  "9月",
        "day":  "27",
        "weekday":  "日",
        "name":  "箕郷ふるさと祭り花火大会",
        "prefecture":  "群馬県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "高崎市/高崎市ふれあい公園付近河川敷",
        "scale":  "約1500発",
        "status":  "予定",
        "tags":  [
                     "群馬県",
                     "9月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-03",
        "dateText":  "2026-10-03",
        "month":  "10月",
        "day":  "03",
        "weekday":  "土",
        "name":  "第85回 川崎市制記念多摩川花火大会",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "川崎市高津区/多摩川河川敷",
        "scale":  "約6,000発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-03",
        "dateText":  "2026-10-03",
        "month":  "10月",
        "day":  "03",
        "weekday":  "土",
        "name":  "第48回 世田谷区たまがわ花火大会",
        "prefecture":  "東京都",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "世田谷区/二子玉川緑地運動場",
        "scale":  "約6,000発",
        "status":  "予定",
        "tags":  [
                     "東京都",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-10",
        "dateText":  "2026-10-10",
        "month":  "10月",
        "day":  "10",
        "weekday":  "土",
        "name":  "第80回 あつぎ鮎まつり",
        "prefecture":  "神奈川県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "厚木市/相模川河川敷(三川合流点)",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "神奈川県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-11",
        "dateText":  "2026-10-11",
        "month":  "10月",
        "day":  "11",
        "weekday":  "日",
        "name":  "高田松原花火",
        "prefecture":  "岩手県",
        "area":  "tohoku",
        "areaLabel":  "東北",
        "venue":  "陸前高田市/高田松原運動公園",
        "scale":  "約1万5000発",
        "status":  "予定",
        "tags":  [
                     "岩手県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-11",
        "dateText":  "2026-10-11",
        "month":  "10月",
        "day":  "11",
        "weekday":  "日",
        "name":  "第8回 あいら市花火大会",
        "prefecture":  "鹿児島県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "姶良市/加治木港",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "鹿児島県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-17",
        "dateText":  "2026-10-17",
        "month":  "10月",
        "day":  "17",
        "weekday":  "土",
        "name":  "第39回 やつしろ全国花火競技大会",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "八代市/球磨川河川緑地(新萩原橋上流)",
        "scale":  "1万4000発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-17",
        "dateText":  "2026-10-17",
        "month":  "10月",
        "day":  "17",
        "weekday":  "土",
        "name":  "第38回 なにわ淀川花火大会",
        "prefecture":  "大阪府",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "大阪市淀川区/新御堂筋淀川鉄橋から下流の淀川河川敷",
        "scale":  "未定",
        "status":  "予定",
        "tags":  [
                     "大阪府",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-17",
        "dateText":  "2026-10-17",
        "month":  "10月",
        "day":  "17",
        "weekday":  "土",
        "name":  "与一の里大田原 佐久山納涼花火大会",
        "prefecture":  "栃木県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "大田原市/箒川岩井橋付近、佐久山運動公園",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "栃木県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-18",
        "dateText":  "2026-10-18",
        "month":  "10月",
        "day":  "18",
        "weekday":  "日",
        "name":  "第75回 あゆまつり",
        "prefecture":  "熊本県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "上益城郡甲佐町/緑川河川敷、中甲橋グリーンパーク",
        "scale":  "約3000発",
        "status":  "予定",
        "tags":  [
                     "熊本県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-10-24",
        "dateText":  "2026-10-24",
        "month":  "10月",
        "day":  "24",
        "weekday":  "土",
        "name":  "くきのうみ花火の祭典",
        "prefecture":  "福岡県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "北九州市若松区/洞海湾、若戸大橋周辺",
        "scale":  "約5000発",
        "status":  "予定",
        "tags":  [
                     "福岡県",
                     "10月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-11-07",
        "dateText":  "2026-11-07",
        "month":  "11月",
        "day":  "07",
        "weekday":  "土",
        "name":  "猪名川花火大会 2026",
        "prefecture":  "兵庫県",
        "area":  "kansai",
        "areaLabel":  "関西",
        "venue":  "川西市/猪名川河川敷",
        "scale":  "約4000発",
        "status":  "予定",
        "tags":  [
                     "兵庫県",
                     "11月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-11-14",
        "dateText":  "2026-11-14",
        "month":  "11月",
        "day":  "14",
        "weekday":  "土",
        "name":  "ハウステンボス 第13回 九州一 大花火まつり",
        "prefecture":  "長崎県",
        "area":  "kyushu",
        "areaLabel":  "九州",
        "venue":  "佐世保市/ハウステンボス",
        "scale":  "2万2000発",
        "status":  "予定",
        "tags":  [
                     "長崎県",
                     "11月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-11-21",
        "dateText":  "2026-11-21",
        "month":  "11月",
        "day":  "21",
        "weekday":  "土",
        "name":  "大子町花火大会松沼橋 防災道の駅完成記念大会(仮)",
        "prefecture":  "茨城県",
        "area":  "kanto",
        "areaLabel":  "関東",
        "venue":  "久慈郡大子町/久慈川・押川合流点中州",
        "scale":  "約3300発",
        "status":  "予定",
        "tags":  [
                     "茨城県",
                     "11月開催",
                     "予定"
                 ]
    },
    {
        "date":  "2026-11-23",
        "dateText":  "2026-11-23",
        "month":  "11月",
        "day":  "23",
        "weekday":  "月",
        "name":  "第120回 長野えびす講煙火大会",
        "prefecture":  "長野県",
        "area":  "koshinetsu",
        "areaLabel":  "甲信越",
        "venue":  "長野市/長野大橋西側  犀川第2緑地",
        "scale":  "約1万発",
        "status":  "予定",
        "tags":  [
                     "長野県",
                     "11月開催",
                     "予定"
                 ]
    }
];
